import { useTranslation } from 'react-i18next';
import './BottomNav.css';

export default function BottomNav({ active, cartQuantity, wishlistCount, onNavigate, onOpenCategories, onOpenAccount }) {
  const { t } = useTranslation();
  return (
    <nav className="bn-bar" role="navigation" aria-label="Primary">
      <button
        className={`bn-item${active === 'home' ? ' active' : ''}`}
        onClick={() => onNavigate('home')}
        aria-label={t("nav.home")}
        aria-current={active === 'home' ? 'page' : undefined}
      >
        {active === 'home' ? (
          <svg width="23" height="23" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="1" strokeLinejoin="round">
            <path d="M3 9.5l9-7 9 7v11a1 1 0 0 1-1 1h-5v-7H10v7H4a1 1 0 0 1-1-1z"/>
          </svg>
        ) : (
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/>
          </svg>
        )}
        <span className="bn-label">{t("nav.home")}</span>
      </button>

      <button className="bn-item" onClick={onOpenCategories} aria-label={t("nav.categories")}>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
        </svg>
        <span className="bn-label">{t("nav.categories")}</span>
      </button>

      <button
        className={`bn-item${active === 'wishlist' ? ' active' : ''}`}
        onClick={() => onNavigate('wishlist')}
        aria-label={t("nav.wishlist")}
        aria-current={active === 'wishlist' ? 'page' : undefined}
      >
        <span className="bn-icon-wrap">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
          </svg>
          {wishlistCount > 0 && <span className="bn-badge bn-badge-count">{wishlistCount}</span>}
        </span>
        <span className="bn-label">{t("nav.wishlist")}</span>
      </button>

      <button
        className={`bn-item${active === 'cart' ? ' active' : ''}`}
        onClick={() => onNavigate('cart')}
        aria-label={t("nav.cart")}
      >
        <span className="bn-icon-wrap">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
          </svg>
          {cartQuantity > 0 && <span className="bn-badge">{cartQuantity}</span>}
        </span>
        <span className="bn-label">{t("nav.cart")}</span>
      </button>

      <button
        className={`bn-item${active === 'dashboard' ? ' active' : ''}`}
        onClick={onOpenAccount}
        aria-label={t("nav.account")}
        aria-haspopup="menu"
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
        </svg>
        <span className="bn-label">{t("nav.account")}</span>
      </button>
    </nav>
  );
}
